import React from "react";

export interface ContentEntry {
  label: string;
  value?: string | string[];
  displayAs?: string;
}

interface QuestionAnswerDisplayProps {
  content: Record<string, ContentEntry>;
  className?: string;
}

export default function QuestionAnswerDisplay({
  content,
  className = "",
}: QuestionAnswerDisplayProps) {
  const renderContent = () => {
    if (!content) {
      return (
        <div className="space-y-3">
          <div className="flex justify-start">
            <div className="bg-electrum-50 rounded-lg p-3 max-w-[80%]">
              <p className="font-medium text-sm whitespace-normal break-words">
                Content
              </p>
            </div>
          </div>
          <div className="flex justify-end">
            <div className="bg-electrum-100 rounded-lg p-3 max-w-[80%]">
              <p className="text-sm whitespace-normal break-words">
                No content available
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="space-y-3">
        {Object.entries(content).map(([key, entry], index) => {
          if (key === "completed") return null;
          const contentEntry = entry as ContentEntry;

          return (
            <div
              key={index}
              className="border-t border-electrum-100 pt-3 first:border-t-0 first:pt-0"
            >
              <div className="flex flex-col space-y-2">
                {/* Question - Left aligned */}
                <div className="flex justify-start">
                  <div className="bg-electrum-50 rounded-lg p-3 max-w-[80%]">
                    <p className="font-medium text-sm whitespace-normal break-words">
                      {contentEntry.label || key}
                    </p>
                  </div>
                </div>

                {/* Answer - Right */}
                <div className="flex justify-end">
                  <div className="bg-electrum-100 rounded-lg p-3 max-w-[80%]">
                    {contentEntry.displayAs ? (
                      <p className="mt-1 text-sm whitespace-pre-wrap">
                        {contentEntry.displayAs}
                      </p>
                    ) : (
                      <>
                        {Array.isArray(contentEntry.value) ? (
                          contentEntry.value.length > 1 ? (
                            <ul className="list-disc pl-5 mt-1 text-sm">
                              {contentEntry.value.map((item, itemIndex) => (
                                <li
                                  key={itemIndex}
                                  className="whitespace-normal break-words"
                                >
                                  {item}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="mt-1 text-sm whitespace-normal break-words">
                              {contentEntry.value[0]}
                            </p>
                          )
                        ) : (
                          <p className="mt-1 text-sm whitespace-normal break-words">
                            {contentEntry.value || "No content"}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className={`space-y-3 bg-white p-4 rounded-lg ${className}`}>
      {renderContent()}
    </div>
  );
}
